import { render, staticRenderFns } from "./LessonMenuItem.vue?vue&type=template&id=038dbc16&"
import script from "./LessonMenuItem.vue?vue&type=script&lang=js&"
export * from "./LessonMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./LessonMenuItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VIcon,VRow})
